import axios from 'axios';
import Vue from 'vue';
import { Message } from 'view-design';
import { getStorage } from '@/utils/storage';
import { ignoreErrorMsg } from '@/config/enum.config';
import router from '@/router/router';
import { clearState } from "@/utils/loginStatePersist.js";

const REQUEST_TIMEOUT = 120;// 请求超时时间：秒

const { CancelToken } = axios;
// 向服务器发送请求返回的状态
const validateStatus = (status) => {
  if (status >= 200 && status < 300) {
    return true;
  }
  if (status === 403) {
    Message.error('登录过期，请重新登录');
    clearState();
    router.push({
      name: 'login',
    });
    return false;
  }
  return false;
};
// 处理返回的msg
const transformErrorMsg = (msg) => {
  if (msg.indexOf(' / ') > -1) {
    return msg.split(' / ')[1];
  }
  return msg;
};
// 对response 数据进行处理
const httpResponse = ({ data }) => {
  switch (data.code) {
    case 200:
      return data.data || {};
    default:
      break;
  }
  Message.error(transformErrorMsg(data.msg));
  return false;
};

/**
 * Requests a URL, return a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "axios"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options = {}) {
  const {
    method = 'get', // 请求方法
    headers = {}, // 需要自定义的请求头
    params = {}, // 请求query
    body = {}, // 请求body
    events = {}, // 上传，下载进度事件
    isGlobal = false, // 切换页面不需要取消的请求
    others = {}, // 其他配置参数
  } = options;
  const {
    onUploadProgress = () => {},
    onDownloadProgress = () => {},
  } = events;

  const { language = 'zh-CN', token = '' } = getStorage('vuex') || {};

  let requestData = JSON.stringify(body);
  let requestHeaders = {
    language,
    'Content-type': 'application/json; charset=UTF-8',
    Authorization: `Bearer ${token}`,
    ...headers,
  };
  // 判断传入的参数是否是formData
  if (Object.prototype.toString.call(body) === '[object FormData]') {
    requestData = body;
    requestHeaders = {
      Authorization: `Bearer ${token}`,
      ...headers,
    };
  }

  const newUrl = process.env.VUE_APP_REQUEST_BASE_URL + url;

  return axios({
    method,
    url: newUrl,
    params,
    data: requestData,
    timeout: REQUEST_TIMEOUT * 1000,
    headers: requestHeaders,
    baseURL: '',
    cancelToken: new CancelToken((c) => {
      // 缓存所有的请求到cancelList中，在切换页面的时候做取消
      if (!isGlobal) {
        Vue.prototype.cancelList.push(c);
      }
    }),
    // 上传进度事件
    onUploadProgress,
    // 下载进度事件
    onDownloadProgress,
    validateStatus,
    ...others,
  }).then((response) => httpResponse(response))
    .catch((error) => {
      // 如果是需要忽略请求，不需要报错
      if (ignoreErrorMsg.indexOf(error.toString()) === -1) {
        if (error.response) {
          // 请求已发出，但服务器响应的状态码不在 2xx 范围内
          console.error(error.response);
        } else {
          console.error('Error', error.message);
        }
        Message.error('网络错误，请检查网络或联系管理员！');
      }
    });
}
